<script setup lang="ts">
import UniversalFilterTree from '@/components/createdUi/UniversalFilterTree.vue'

const props = defineProps<{
  store: any
  tempSelectedFilters: Record<string, any[]>
  filterMenus: Record<string, boolean>
  getFilterIcon: (isActive: boolean) => string
}>()

const emit = defineEmits<{
  'filter-click': [fieldKey: string]
  'filter-apply': [fieldKey: string]
}>()

const isDepartmentFilterActive = computed(() =>
  (props.store.filters.departments?.length ?? 0) > 0,
)
const isStatusFilterActive = computed(() =>
  (props.store.filters.status?.length ?? 0) > 0,
)
const isRiskFilterActive = computed(() =>
  (props.store.filters.risk?.length ?? 0) > 0,
)

const applyFilter = (filterKey: string) => {
  emit('filter-apply', filterKey)
}

const handleFilterClick = (filterKey: string) => {
  emit('filter-click', filterKey)
}
</script>

<template>
  <VMenu v-model="filterMenus.departments" :close-on-content-click="false" location="bottom start">
    <template #activator="{ props: menuProps }">
      <VBtn
        v-bind="menuProps"
        :prepend-icon="getFilterIcon(isDepartmentFilterActive)"
        variant="outlined"
        color="secondary"
        class="text-color-secondary"
        :loading="store.filterLoading.departments"
        :class="{ 'active-filter': isDepartmentFilterActive }"
        @click="handleFilterClick('departments')"
      >
        Отделение
      </VBtn>
    </template>
    <UniversalFilterTree
      field-key="departments"
      :store="store"
      :model-value="tempSelectedFilters.departments || []"
      placeholder="Поиск отделения"
      @update:model-value="tempSelectedFilters.departments = $event"
      @apply="applyFilter('departments')"
    />
  </VMenu>

  <VMenu v-model="filterMenus.status" :close-on-content-click="false" location="bottom start">
    <template #activator="{ props: menuProps }">
      <VBtn
        v-bind="menuProps"
        :prepend-icon="getFilterIcon(isStatusFilterActive)"
        variant="outlined"
        color="secondary"
        class="text-color-secondary"
        :loading="store.filterLoading.status"
        :class="{ 'active-filter': isStatusFilterActive }"
        @click="handleFilterClick('status')"
      >
        Статус
      </VBtn>
    </template>
    <UniversalFilterTree
      field-key="status"
      :store="store"
      :model-value="tempSelectedFilters.status || []"
      placeholder="Поиск статуса"
      @update:model-value="tempSelectedFilters.status = $event"
      @apply="applyFilter('status')"
    />
  </VMenu>

  <VMenu v-model="filterMenus.risk" :close-on-content-click="false" location="bottom start">
    <template #activator="{ props: menuProps }">
      <VBtn
        v-bind="menuProps"
        :prepend-icon="getFilterIcon(isRiskFilterActive)"
        variant="outlined"
        color="secondary"
        class="text-color-secondary"
        :loading="store.filterLoading.risk"
        :class="{ 'active-filter': isRiskFilterActive }"
        @click="handleFilterClick('risk')"
      >
        Риск
      </VBtn>
    </template>
    <UniversalFilterTree
      field-key="risk"
      :store="store"
      :model-value="tempSelectedFilters.risk || []"
      placeholder="Поиск риска"
      @update:model-value="tempSelectedFilters.risk = $event"
      @apply="applyFilter('risk')"
    />
  </VMenu>
</template>

<style scoped lang="scss">
.active-filter {
  border-color: rgb(var(--v-theme-primary)) !important;
  color: rgb(var(--v-theme-primary)) !important;
}
</style>
